import React from 'react'
import classNames from 'classnames'
import * as styles from './salesforce-form.module.scss'

import ReCAPTCHA from 'react-google-recaptcha'

import Button from '../../common/Button'
import useCaptcha from '../../hooks/useCaptcha'

export default function SFReseller() {
  const { captchaValue, setRecaptchaLoaded, setCaptchaValue, handleSubmit } =
    useCaptcha()

  return (
    <>
      {/*  ----------------------------------------------------------------------  */}
      {/*  NOTE: Please add the following <META> element to your page <HEAD>.      */}
      {/*  If necessary, please modify the charset parameter to specify the        */}
      {/*  character set of your HTML page.                                        */}
      {/*  ----------------------------------------------------------------------  */}
      <meta httpEquiv="Content-type" content="text/html; charset=UTF-8" />
      {/* <Script
        src="https://www.google.com/recaptcha/api.js"
        // onLoad={recaptchaLoad}
      /> */}

      <form
        action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00D5f000006OK6g"
        method="POST"
        className={styles.form}
        onSubmit={handleSubmit}
      >
        {/*  ----------------------------------------------------------------------  */}
        {/* HIDDEN FIELDS */}

        <input
          type="hidden"
          name="captcha_settings"
          value='{"keyname":"Form_Captcha","fallback":"true","orgId":"00D5f000006OK6g","ts":""}'
        />

        <input type="hidden" name="oid" defaultValue="00D5f000006OK6g" />
        <input
          type="hidden"
          name="retURL"
          defaultValue="https://xealenergy.com/success"
        />
        <input
          type="hidden"
          name="00N5f00000gr9lF"
          defaultValue="Marketing Generated"
        />
        <input type="hidden" name="lead_source" defaultValue="Search" />
        {/* required for state picklist */}
        <input type="text" name="country_code" value="US" hidden />
        {/*  ----------------------------------------------------------------------  */}

        {/*  ----------------------------------------------------------------------  */}
        {/*  NOTE: These fields are optional debugging elements. Please uncomment    */}
        {/*  these lines if you wish to test in debug mode.                          */}
        {process.env.NODE_ENV !== 'production' && (
          <>
            <input type="hidden" name="debug" value="1" />
            <input
              type="hidden"
              name="debugEmail"
              value="drew@secretsauce.design"
            />
          </>
        )}
        {/*  ----------------------------------------------------------------------  */}

        <div className={styles.row}>
          <div className={styles.col}>
            <label htmlFor="first_name">First Name*</label>
            <input
              id="first_name"
              maxLength={40}
              name="first_name"
              size={20}
              type="text"
              required
            />
          </div>
          <div className={styles.col}>
            <label htmlFor="last_name">Last Name*</label>
            <input
              id="last_name"
              maxLength={80}
              name="last_name"
              size={20}
              type="text"
              required
            />
          </div>
        </div>

        <div className={styles.row}>
          <div className={styles.col}>
            <label htmlFor="email">Email*</label>
            <input
              id="email"
              maxLength={80}
              name="email"
              size={20}
              type="text"
              required
            />
          </div>
          <div className={styles.col}>
            <label htmlFor="phone">Phone*</label>
            <input
              id="phone"
              maxLength={40}
              name="phone"
              size={20}
              type="text"
              required
            />
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.col}>
            <label htmlFor="company">Company*</label>
            <input
              id="company"
              maxLength={40}
              name="company"
              size={20}
              type="text"
              required
            />
          </div>
          <div className={styles.col}>
            <label htmlFor="title">Title*</label>
            <input
              id="title"
              maxLength={40}
              name="title"
              size={20}
              type="text"
              required
            />
          </div>
        </div>
        <div className={classNames(styles.col, styles.position)}>
          <label htmlFor="position">Position</label>
          <input
            id="position"
            maxLength="40"
            name="position"
            size="20"
            type="text"
          />
        </div>
        <div className={styles.col}>
          <label htmlFor="state_code" required>
            State/Province*
          </label>
          <select id="state_code" name="state_code" required>
            <option value="">Please Select</option>
            <option value="AL">Alabama</option>
            <option value="AK">Alaska</option>
            <option value="AZ">Arizona</option>
            <option value="AR">Arkansas</option>
            <option value="CA">California</option>
            <option value="CO">Colorado</option>
            <option value="CT">Connecticut</option>
            <option value="DE">Delaware</option>
            <option value="DC">District of Columbia</option>
            <option value="FL">Florida</option>
            <option value="GA">Georgia</option>
            <option value="HI">Hawaii</option>
            <option value="ID">Idaho</option>
            <option value="IL">Illinois</option>
            <option value="IN">Indiana</option>
            <option value="IA">Iowa</option>
            <option value="KS">Kansas</option>
            <option value="KY">Kentucky</option>
            <option value="LA">Louisiana</option>
            <option value="ME">Maine</option>
            <option value="MD">Maryland</option>
            <option value="MA">Massachusetts</option>
            <option value="MI">Michigan</option>
            <option value="MN">Minnesota</option>
            <option value="MS">Mississippi</option>
            <option value="MO">Missouri</option>
            <option value="MT">Montana</option>
            <option value="NE">Nebraska</option>
            <option value="NV">Nevada</option>
            <option value="NH">New Hampshire</option>
            <option value="NJ">New Jersey</option>
            <option value="NM">New Mexico</option>
            <option value="NY">New York</option>
            <option value="NC">North Carolina</option>
            <option value="ND">North Dakota</option>
            <option value="OH">Ohio</option>
            <option value="OK">Oklahoma</option>
            <option value="OR">Oregon</option>
            <option value="PA">Pennsylvania</option>
            <option value="RI">Rhode Island</option>
            <option value="SC">South Carolina</option>
            <option value="SD">South Dakota</option>
            <option value="TN">Tennessee</option>
            <option value="TX">Texas</option>
            <option value="UT">Utah</option>
            <option value="VT">Vermont</option>
            <option value="VA">Virginia</option>
            <option value="WA">Washington</option>
            <option value="WV">West Virginia</option>
            <option value="WI">Wisconsin</option>
            <option value="WY">Wyoming</option>
          </select>
        </div>
        <div className={styles.col}>
          <label htmlFor="00N5f00000hOTbO">Partner Type*</label>
          <select
            id="00N5f00000hOTbO"
            name="00N5f00000hOTbO"
            title="Partner Type"
            required
          >
            <option value="">Please Select</option>
            <option value="Value Added Reseller (VAR)">
              Value Added Reseller (VAR)
            </option>
            <option value="Value Added Distributor (VAD)">
              Value Added Distributor (VAD)
            </option>
            <option value="Charge Point Operator (CPO)">
              Charge Point Operator (CPO)
            </option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div className={styles.col}>
          <label htmlFor="00N5f00000hOTbT">
            Are you already working with other charger brands?*
          </label>

          <select
            id="00N5f00000hOTbT"
            name="00N5f00000hOTbT"
            title="Are you already working with other charger brands?"
            required
          >
            <option value="">Please Select</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>
        <div className={styles.col}>
          <label htmlFor="00N5f00000hOTbY">
            How many units do you expect to sell in the next 12 months?*
          </label>

          <select
            id="00N5f00000hOTbY"
            name="00N5f00000hOTbY"
            title="How many units do you expect to sell in the next 12 months?"
            required
          >
            <option value="">Please Select</option>
            <option value="0 - 20">0 - 20</option>
            <option value="20 - 50">20 - 50</option>
            <option value="50 - 100">50 - 100</option>
            <option value="More than 100">More than 100</option>
          </select>
        </div>
        <div className={styles.col}>
          <label htmlFor="00N5f00000hOTbd">
            Which property type do you mostly work with?*
          </label>

          <select
            id="00N5f00000hOTbd"
            name="00N5f00000hOTbd"
            title="Which property type do you mostly work with?"
            required
          >
            <option value="">Please Select</option>
            <option value="Commercial">Commercial</option>
            <option value="Single family">Single family</option>
            <option value="Multi family">Multi family</option>
          </select>
        </div>

        <div
          className="g-recaptcha"
          data-sitekey="6LeVKcEqAAAAAHQjJHNr9pFubULoJrFS6GlH6vrf"
        />

        <div>
          <ReCAPTCHA
            sitekey="6LeVKcEqAAAAAHQjJHNr9pFubULoJrFS6GlH6vrf"
            asyncScriptOnLoad={() => setRecaptchaLoaded(true)}
            onChange={(value) => setCaptchaValue(value)}
          />
          {!captchaValue && (
            <p className={styles.errorMsg}>Captcha is required.</p>
          )}
        </div>

        <div className={styles.col}>
          <Button type="submit" disabled={!captchaValue}>
            Submit
          </Button>
        </div>
      </form>
    </>
  )
}
